/* Cozyleigh "Saved pieces" (wishlist). Saves live in this browser: localStorage "cl_saved_v1" = [{ h: handle, t: savedAt }].
   - Every [data-cl-save="<handle>"] button toggles a save (cards, product page) and mirrors aria-pressed.
   - [data-cl-saved-list] (account page) renders each saved piece from /products/<handle>?view=saved-card
     (templates/product.saved-card.liquid), newest first, and hides itself when nothing is saved.
   - window.clSaved.add([handles]) saves several at once without unsaving any (the setup builder's "Save this setup").
   - window.clSaved.render() repaints every list now (the points panel adds its list when its Saved tab opens).
   - [data-cl-saved-setup] (account page, its own block, not inside the saved-pieces list) shows a "pick up your setup" link when the builder has a saved setup on
     this device (localStorage "cl_setup_saved" = { u: builder path, n: item count, t: savedAt }).
   Account sync (signed-in customers only, body.customer-logged-in): saves, the saved setup, the avatar ("cl_avatar") and
   email interests are also kept on the shop's engagement endpoint (/apps/engagement/account/state), so they follow the
   customer to every device. The first time a browser syncs it merges what it already has with the account; after that the
   account wins, and every save/unsave is pushed. window.clSaved.patchAccount({...}) sends other fields; the loaded state
   is window.clAccountState and the "cl:account-state" event. Guests are unchanged (this browser only).
   Hearts count (everyone, guests too): every save/unsave is also sent to /apps/engagement/hearts with a random id for
   this browser ("cl_did"), so the shop knows how many people have each piece saved. One browser counts once, a signed-in
   customer once across devices. Saves made before counting started are sent once ("cl_hearts_rep" remembers who sent
   them, so signing in sends them again and the guest heart becomes the account's). [data-cl-save-count="<handle>"]
   shows "N people saved this" (or data-cl-count-label, e.g. "love this" on the prototype cards; the product page shows
   the heart only); the server only returns counts big enough to show. window.clHearts.send(saved, unsaved) is used by
   assets/cozyleigh-prototypes.js, whose hearts count as "prototype--<handle>" and are sent once from older browsers too. */
(function () {
  var KEY = 'cl_saved_v1';
  function read() { try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 60))); } catch (e) {} }
  function has(h) { return read().some(function (x) { return x.h === h; }); }
  var SYNC_URL = '/apps/engagement/account/state', SYNC_MARK = 'cl_acct_sync', SYNC_AT = 'cl_acct_sync_at', SETUP_KEY = 'cl_setup_saved', AVATAR_KEY = 'cl_avatar';
  var HANDLE_OK = /^[a-z0-9][a-z0-9-]{0,254}$/;
  var sync = { started: false, dirty: false, timer: 0 };
  function signedIn() { return !!(document.body && document.body.classList.contains('customer-logged-in')); }
  function customerId() { try { return String(window.clAccountCid || (window.__st && window.__st.cid) || ''); } catch (e) { return ''; } }
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function api(method, body) {
    return fetch(SYNC_URL, { method: method, credentials: 'same-origin', cache: 'no-store',
      headers: body ? { 'Content-Type': 'application/json' } : {}, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { if (!r.ok) throw new Error('account sync ' + r.status); return r.json(); });
  }
  function cleanSaved(list) {
    return (list || []).filter(function (x) { return x && HANDLE_OK.test(x.h || '') && isFinite(x.t) && x.t >= 0; })
      .map(function (x) { return { h: x.h, t: Math.floor(x.t) }; });
  }
  function mergeSaved(a, b) {
    var m = {};
    cleanSaved(a).concat(cleanSaved(b)).forEach(function (x) { if (!m[x.h] || x.t > m[x.h].t) m[x.h] = x; });
    return Object.keys(m).map(function (k) { return m[k]; }).sort(function (p, q) { return q.t - p.t; }).slice(0, 60);
  }
  function sameSaved(a, b) {
    a = cleanSaved(a); b = cleanSaved(b);
    return a.length === b.length && a.every(function (x, i) { return x.h === b[i].h && x.t === b[i].t; });
  }
  function readSetup() {
    try {
      var s = JSON.parse(lsGet(SETUP_KEY) || 'null');
      if (s && s.u && Number(s.n) > 0 && /^\/(?!\/)[^\s\\]*$/.test(s.u) && s.u.length <= 500 && isFinite(s.t)) return { u: s.u, n: String(s.n).slice(0, 120), t: Math.floor(s.t) };
    } catch (e) {}
    return null;
  }
  function announce(state) {
    window.clAccountState = state;
    try { document.dispatchEvent(new CustomEvent('cl:account-state', { detail: state })); } catch (e) {}
  }
  function pushSaved() {
    sync.timer = 0;
    api('POST', { saved: cleanSaved(read()) }).then(function (st) { window.clAccountState = st; }).catch(function () {});
  }
  function schedulePush() {
    if (!signedIn()) return;
    sync.dirty = true; clearTimeout(sync.timer);
    sync.timer = setTimeout(pushSaved, 700);
  }
  /* Pull the account's state; merge on a browser's first sync, otherwise the account wins. */
  function initSync(force) {
    if (sync.started || !signedIn()) return; sync.started = true;
    var onAccountPage = !!document.querySelector('[data-cl-saved-list], [data-cl-saved-setup]');
    var mark = lsGet(SYNC_MARK), at = Number(lsGet(SYNC_AT)) || 0;
    if (mark && !onAccountPage && !force && Date.now() - at < 600000) return;
    api('GET').then(function (srv) {
      var patch = {}, local = read(), first = !mark;
      var saved = first ? mergeSaved(local, srv.saved) : (sync.dirty ? cleanSaved(local) : cleanSaved(srv.saved));
      if (!sameSaved(saved, local)) { write(saved); reportAll(true); }
      if (!sameSaved(saved, srv.saved)) patch.saved = cleanSaved(saved);
      var ls = readSetup();
      if (ls && (!srv.setup || ls.t > srv.setup.t)) patch.setup = ls;
      else if (srv.setup) { lsSet(SETUP_KEY, JSON.stringify({ u: srv.setup.u, n: Number(srv.setup.n) || srv.setup.n, t: srv.setup.t })); }
      var la = lsGet(AVATAR_KEY);
      if (srv.avatar) lsSet(AVATAR_KEY, srv.avatar); else if (la) patch.avatar = la;
      var state = { saved: saved, setup: patch.setup || srv.setup || null, avatar: srv.avatar || patch.avatar || null,
        emailInterests: srv.emailInterests === undefined ? null : srv.emailInterests, updatedAt: srv.updatedAt || null };
      announce(state);
      boot();
      var finish = function () { lsSet(SYNC_MARK, customerId() || '1'); lsSet(SYNC_AT, String(Date.now())); };
      if (Object.keys(patch).length) return api('POST', patch).then(function (st) { announce(st); boot(); finish(); });
      finish();
    }).catch(function () { sync.started = false; });
  }
  function patchAccount(fields) {
    return api('POST', fields).then(function (st) { announce(st); return st; });
  }
  /* Hearts count. Fire and forget: a failed send never gets in the way of saving. */
  var HEARTS_URL = '/apps/engagement/hearts', DEVICE_KEY = 'cl_did', REPORTED_KEY = 'cl_hearts_rep2';
  function deviceId() {
    var id = lsGet(DEVICE_KEY);
    if (id && /^[A-Za-z0-9_-]{16,64}$/.test(id)) return id;
    try {
      var bytes = new Uint8Array(16); crypto.getRandomValues(bytes);
      id = Array.prototype.map.call(bytes, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
    } catch (e) { id = (Date.now().toString(36) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2)).slice(0, 32); }
    lsSet(DEVICE_KEY, id);
    return lsGet(DEVICE_KEY) === id ? id : null;
  }
  function whoReported() { return signedIn() ? 'c:' + (customerId() || '?') : 'g'; }
  function sendHearts(saved, unsaved) {
    var device = deviceId();
    saved = (saved || []).filter(function (h) { return HANDLE_OK.test(h); }).slice(0, 60);
    unsaved = (unsaved || []).filter(function (h) { return HANDLE_OK.test(h); }).slice(0, 60);
    if (!device || !(saved.length + unsaved.length) || !window.fetch) return Promise.resolve(false);
    return fetch(HEARTS_URL, { method: 'POST', credentials: 'same-origin', cache: 'no-store', keepalive: true,
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ device: device, saved: saved, unsaved: unsaved }) })
      .then(function (r) { if (!r.ok) throw new Error('hearts ' + r.status); return r.json(); })
      .then(function (data) {
        var counts = (data && data.counts) || {};
        saved.concat(unsaved).forEach(function (h) { heartCounts[h] = counts[h] || 0; });
        paintCounts();
        return true;
      }).catch(function () { return false; });
  }
  /* Everything saved in this browser, sent once per who's here (guest, or each signed-in customer). */
  function reportAll(force) {
    var who = whoReported();
    if (!force && lsGet(REPORTED_KEY) === who) return;
    var handles = read().map(function (x) { return x.h; }).concat(protoHearts());
    if (!handles.length) { lsSet(REPORTED_KEY, who); return; }
    sendHearts(handles, []).then(function (ok) { if (ok) lsSet(REPORTED_KEY, who); });
  }
  /* Prototype hearts ("I'd love this", assets/cozyleigh-prototypes.js) kept in this browser before counting started. */
  function protoHearts() {
    var out = [];
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i), v = k && k.indexOf('cl_proto_') === 0 ? localStorage.getItem(k) : null;
        if ((v === 'hearted' || v === 'joined') && HANDLE_OK.test(k.slice(9))) out.push('prototype--' + k.slice(9));
      }
    } catch (e) {}
    return out.slice(0, 20);
  }
  /* The tap: .cl-pop squishes and springs the heart, then a blush ring and six Fa petals (peach, coral, apricot, matcha)
     fly out; un-saving is a small .cl-unpop. Styles: snippets/cozyleigh-scripts. Skipped for reduced motion. */
  var PETALS = ['#FEDBAE', '#F59178', '#FBB393', '#C9D49E', '#F0BCB0', '#E28D69'];
  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function celebrate(btn, on) {
    if (!btn || reduceMotion) return;
    btn.classList.remove('cl-pop', 'cl-unpop'); void btn.offsetWidth;
    btn.classList.add(on ? 'cl-pop' : 'cl-unpop');
    setTimeout(function () { btn.classList.remove('cl-pop', 'cl-unpop'); }, 600);
    if (!on) return;
    var burst = document.createElement('span');
    burst.className = 'cl-heart-burst'; burst.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 6; i++) {
      var a = (i / 6) * Math.PI * 2 - Math.PI / 2 + (Math.random() - .5) * .5, d = 20 + Math.random() * 10;
      var p = document.createElement('i');
      p.style.setProperty('--x', Math.round(Math.cos(a) * d) + 'px');
      p.style.setProperty('--y', Math.round(Math.sin(a) * d) + 'px');
      p.style.setProperty('--r', Math.round(Math.random() * 90 - 45) + 'deg');
      p.style.setProperty('--c', PETALS[i % PETALS.length]);
      burst.appendChild(p);
    }
    var svg = btn.querySelector('svg');
    if (svg && svg.parentNode === btn) {
      var r = svg.getBoundingClientRect(), br = btn.getBoundingClientRect();
      burst.style.left = (r.left - br.left + r.width / 2) + 'px'; burst.style.top = (r.top - br.top + r.height / 2) + 'px';
    }
    btn.appendChild(burst);
    setTimeout(function () { if (burst.parentNode) burst.parentNode.removeChild(burst); }, 1000);
  }
  /* Only write text that changed: writing the same text still counts as a page change, which wakes the
     MutationObserver at the bottom, which paints again, about 8 times a second forever (Nov 2026). */
  function setText(el, text) { if (el.textContent !== text) el.textContent = text; }
  /* The header heart and the menu's Saved row: this browser's count, and a small hop when something lands there. */
  function paintBadges(bump) {
    var n = read().length;
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-saved-n]'), function (el) {
      setText(el, n > 99 ? '99+' : String(n));
      if (el.tagName === 'B') el.hidden = !n;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-saved-head]'), function (el) {
      el.classList.toggle('is-empty', !n);
      el.setAttribute('aria-label', n ? 'Saved pieces (' + n + ')' : 'Saved pieces');
      if (bump) celebrate(el, true);
    });
  }
  window.clHearts = { send: function (saved, unsaved) { return sendHearts(saved, unsaved); }, celebrate: celebrate };
  var heartCounts = {}, countsAsked = {};
  function paintCounts() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-save-count]'), function (el) {
      var n = heartCounts[el.getAttribute('data-cl-save-count')] || 0;
      var words = el.getAttribute('data-cl-count-label') || 'saved this';
      var full = (n === 1 ? '1 person ' : n + ' people ') + words;
      if (n > 0) { setText(el, full); el.hidden = false; }
      else { el.hidden = true; setText(el, ''); }
    });
  }
  function loadCounts() {
    var want = [];
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-save-count]'), function (el) {
      var h = el.getAttribute('data-cl-save-count');
      if (HANDLE_OK.test(h) && !countsAsked[h] && want.indexOf(h) === -1) want.push(h);
    });
    if (!want.length || !window.fetch) { paintCounts(); return; }
    want = want.slice(0, 24);
    want.forEach(function (h) { countsAsked[h] = true; });
    fetch(HEARTS_URL + '?h=' + want.map(encodeURIComponent).join(','), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('hearts ' + r.status); return r.json(); })
      .then(function (data) {
        var counts = (data && data.counts) || {};
        want.forEach(function (h) { heartCounts[h] = counts[h] || 0; });
        paintCounts();
      }).catch(function () { /* No retry on this page: every retry is a request through the server's ngrok tunnel,
        and when the tunnel is down or capped the retries kept it down. The counts just stay hidden. */ });
  }
  function toggle(h) {
    var list = read(), on = !has(h);
    list = list.filter(function (x) { return x.h !== h; });
    if (on) list.unshift({ h: h, t: Date.now() });
    write(list); paint(); renderLists(); schedulePush();
    sendHearts(on ? [h] : [], on ? [] : [h]);
    if (window.clAnalytics) window.clAnalytics.componentInteraction('saved_piece', on ? 'save' : 'unsave', h);
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('cozyleigh_saved', { handle: h, saved: on }); } catch (e) {}
    return on;
  }
  function addMany(handles) {
    var list = read(), now = Date.now();
    (handles || []).forEach(function (h) {
      if (!h || list.some(function (x) { return x.h === h; })) return;
      list.unshift({ h: h, t: now });
    });
    write(list); paint(); renderLists(); schedulePush();
    sendHearts(handles, []);
  }
  window.clSaved = { add: addMany, has: has, render: function () { boot(); }, patchAccount: patchAccount };
  function paint() {
    var saved = {}; read().forEach(function (x) { saved[x.h] = true; });
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-save]'), function (b) {
      var on = !!saved[b.getAttribute('data-cl-save')];
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var l = b.querySelector('[data-cl-save-label]'); if (l) setText(l, on ? 'Saved' : 'Save for later');
    });
    paintBadges(false);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cl-save]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var on = toggle(b.getAttribute('data-cl-save'));
    celebrate(b, on);
    if (on) { paintBadges(true); savedNote(); }
  }, true);
  /* The phone menu's "Saved pieces" row closes the menu before the points panel opens on its Saved tab. */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-cl-close-menu]') && window.closeThemeModal) window.closeThemeModal(true);
  }, true);

  /* After a save, once a visit: "Saved for later" with a way to see them (the points panel's Saved tab). Guests also
     hear it's kept on this device and can sign in to keep it everywhere. Styles: assets/cozyleigh-kit.css (.cl-save-note). */
  var noteTimer = 0, NOTE_KEY = 'cl_saved_note';
  function savedNote() {
    try { if (sessionStorage.getItem(NOTE_KEY)) return; sessionStorage.setItem(NOTE_KEY, '1'); } catch (e) {}
    var n = document.querySelector('.cl-save-note');
    if (!n) {
      var back = encodeURIComponent(location.pathname + location.search);
      var panel = !!document.getElementById('clpp-drawer');
      var heart = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19.6s-6.9-4.2-8.3-8.5C2.7 8 4.6 5.2 7.5 5.2c1.9 0 3.2 1 4.5 2.7 1.3-1.7 2.6-2.7 4.5-2.7 2.9 0 4.8 2.8 3.8 5.9-1.4 4.3-8.3 8.5-8.3 8.5Z"/></svg>';
      var where = signedIn()
        ? 'It\'s on your account, so it\'s there on every device.'
        : 'It\'s kept on this device. <a href="/account/login?return_url=' + back + '">Sign in</a> or <a href="/account/register">create an account</a> to keep it everywhere.';
      var cta = panel ? '<button type="button" class="cl-save-note__cta" data-clpp-open-tab="saved">See your saved pieces</button>'
        : (signedIn() ? '<a class="cl-save-note__cta" href="/account#saved">See your saved pieces</a>' : '');
      n = document.createElement('div');
      n.className = 'cl-save-note'; n.setAttribute('role', 'status');
      n.innerHTML = '<div class="cl-save-note__body"><p class="cl-save-note__title">Saved for later' + heart + '</p>' +
        '<p class="cl-save-note__text">' + where + '</p>' + cta + '</div>' +
        '<button type="button" class="cl-save-note__close" aria-label="Close">×</button>';
      n.querySelector('.cl-save-note__close').addEventListener('click', function () { n.classList.remove('is-on'); });
      var go = n.querySelector('.cl-save-note__cta'); if (go) go.addEventListener('click', function () { n.classList.remove('is-on'); });
      document.body.appendChild(n);
    }
    clearTimeout(noteTimer);
    requestAnimationFrame(function () { n.classList.add('is-on'); });
    noteTimer = setTimeout(function () { n.classList.remove('is-on'); }, 8000);
  }

  function renderLists() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-saved-list]'), function (wrap) {
      var grid = wrap.querySelector('[data-cl-saved-grid]'), list = read();
      wrap.hidden = !list.length;
      if (!grid) return;
      var want = list.map(function (x) { return x.h; }).join('|');
      if (grid.getAttribute('data-for') === want) return;
      grid.setAttribute('data-for', want);
      Promise.all(list.slice(0, 12).map(function (x) {
        return fetch('/products/' + encodeURIComponent(x.h) + '?view=saved-card', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (cards) {
        if (grid.getAttribute('data-for') !== want) return;
        grid.innerHTML = cards.filter(function (c) { return c.indexOf('cl-sv') > -1; }).join('');
        wrap.hidden = !grid.children.length;
        paint();
      });
    });
  }
  function renderSetup() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cl-saved-setup]'), function (box) {
      var st = null; try { st = JSON.parse(localStorage.getItem('cl_setup_saved') || 'null'); } catch (e) {}
      var ok = !!(st && st.u && st.n > 0 && /^\/[^\/]/.test(st.u));
      box.hidden = !ok; if (!ok) return;
      var a = box.querySelector('[data-cl-saved-setup-link]'); if (a) a.setAttribute('href', st.u);
      var n = box.querySelector('[data-cl-saved-setup-n]'); if (n) n.textContent = st.n + (st.n === 1 ? ' piece' : ' pieces');
      var w = box.querySelector('[data-cl-saved-setup-when]');
      if (w && st.t) try { w.textContent = (signedIn() ? 'Saved to your account, ' : 'Saved on this device, ') + new Date(st.t).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); } catch (e) {}
    });
  }
  function boot() { paint(); renderLists(); renderSetup(); loadCounts(); }
  function start() { boot(); initSync(); reportAll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('storage', function (e) { if (e.key === KEY || e.key === 'cl_setup_saved') boot(); });
  /* Product cards that arrive later (filters, infinite scroll, quick buy) */
  new MutationObserver(function () { clearTimeout(window.__clSavedT); window.__clSavedT = setTimeout(function () { paint(); loadCounts(); }, 120); }).observe(document.documentElement, { childList: true, subtree: true });
})();
